<app-page-header>
  <span class="page-title">
    <span class="icon w-100" (click)="navigateBack()">
      <i class="pi pi-angle-left"></i> Back To AI Assist
    </span>
  </span>
</app-page-header>

<div class="container-fluid live-speak-assist-container">
  <div class="row">
    <div class="col-12">
      <div class="voice-assistant-wrapper">
        <div class="main-content-area">
          @if (isListening) {
          <div class="voice-input-indicator">
            <div class="listening-animation">
              <div class="wave"></div>
              <div class="wave"></div>
              <div class="wave"></div>
              <div class="wave"></div>
              <div class="wave"></div>
            </div>
            <p class="listening-text">Listening...</p>
            <p class="listening-hint">Speak your question</p>
          </div>
          } @if (!isListening && (isProcessing || aiResponseText || isSpeaking))
          {
          <div class="processing-indicator">
            <div class="ai-avatar">
              <i class="pi pi-android"></i>
            </div>
            @if (isProcessing && !aiResponseText) {
            <div class="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
            } @if (isProcessing && !aiResponseText) {
            <p class="processing-text">AI is thinking...</p>
            } @if (aiResponseText || isSpeaking) {
            <p class="processing-text">
              @if (isSpeaking && visibleSentences.length > 0) {
              <span>
                @for (sentence of visibleSentences; track sentence) {
                <span class="sentence">
                  @for (word of visibleSentenceWords; track word) {
                  <span class="word" [@wordFadeIn]>
                    {{ word }}<span class="space">&nbsp;</span>
                  </span>
                  }
                </span>
                }
              </span>
              } @if (!isSpeaking && displaySentences.length > 0) {
              <span>
                @for (sentence of displaySentences; track sentence; let i =
                $index) {
                <span class="sentence" [@wordFadeIn]>
                  {{ sentence }}@if (i < displaySentences.length - 1) {
                  <span class="sentence-space">&nbsp;</span>
                  }
                </span>
                }
              </span>
              } @if (!isSpeaking && displaySentences.length === 0) {
              <span>
                @for (word of displayWords; track word) {
                <span class="word" [@wordFadeIn]
                  >{{ word }}<span class="space">&nbsp;</span></span
                >
                } @if (aiResponseText && displayWords.length === 0) {
                <span>{{ aiResponseText }}</span>
                }
              </span>
              }
            </p>
            }
          </div>
          } @if (!isListening && !isProcessing && !isSpeaking &&
          !aiResponseText) {
          <div class="empty-state">
            <div class="empty-state-icon">
              <i class="pi pi-microphone"></i>
            </div>
            <h3>Voice Assistant</h3>
            <p>Click the microphone button below to ask a question</p>
          </div>
          }
        </div>

        <div class="voice-control-panel">
          <div class="button-group">
            <button
              class="mic-button"
              [ngClass]="{
                recording: isListening,
                disabled: isProcessing || isSpeaking
              }"
              (click)="toggleListening()"
              [disabled]="isProcessing || isSpeaking"
            >
              <i
                class="pi"
                [ngClass]="isListening ? 'pi-stop-circle' : 'pi-microphone'"
              ></i>
            </button>
            <button class="clear-button" (click)="clearMessages()">
              <i class="pi pi-trash"></i>
            </button>
          </div>
          <div class="status-indicator">
            <span
              class="status-dot"
              [ngClass]="{
                active: isListening,
                processing: isProcessing,
                speaking: isSpeaking
              }"
            ></span>
            <span class="status-text">
              {{
                isListening
                  ? "Recording..."
                  : isProcessing
                  ? "Processing..."
                  : isSpeaking
                  ? "Speaking..."
                  : "Ready"
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
